import { AdvancedMarker } from '@vis.gl/react-google-maps';

const SEARCH_PIN_Z_INDEX = 498;

type SearchPinProps = {
  position: google.maps.LatLngLiteral | null;
};

const SearchPin = ({ position }: SearchPinProps) => {
  if (!position) {
    return null;
  }

  return <AdvancedMarker position={position} zIndex={SEARCH_PIN_Z_INDEX} />;
};

export default SearchPin;
